import AuthorizedUsersSection from './manage-options-sections/authorized-users-section';

function ManageUsers({ options, optionsLoading, onOptionsChanged, currentUserEmail }) {
  if (optionsLoading) {
    return <p className="demo-env-mgmt-label">Loading…</p>;
  }

  return (
    <AuthorizedUsersSection
      users={options.authorizedUsers}
      onChanged={onOptionsChanged}
      currentUserEmail={currentUserEmail}
    />
  );
}

export default ManageUsers;
